export default "__VITE_PUBLIC_ASSET__78013da6__"